import React, { useState, useRef } from "react";
import {
  Button,
  Grid,
  TextField,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";

const SimReplacement = () => {
  const [oldMSISDN, setOldMSISDN] = useState<string>("");
  const [newMSISDN, setNewMSISDN] = useState<string>("");
  const [actionFind, setActionFind] = useState(false);
  const [userDetail, setUserDetail] = useState(null);
  const [activedata, setActiveData] = useState<any>(null);
  const [Open, setOpen] = useState(false);

  const agGridRef = useRef<any>(null);

  const handleReplaceSim = async () => {
    toast.dismiss();
    if (oldMSISDN.trim().length > 9) {
      getUserByMSISDN();
    } else {
      toast.error("Please enter valid inputs.");
    }
  };

  const handleUpdateMsisdn = async () => {
    toast.dismiss();
    if (newMSISDN.trim().length > 9) {
      setOpen(false);
      replaceSimRequest();
      setNewMSISDN("");
    } else {
      toast.error("Please enter valid inputs.");
    }
  };

  const getUserByMSISDN = async () => {
    setUserDetail(null);
    setActionFind(true);
    await axiosInterceptorInstance
      .get(`/product/GetThmCrmCreditSimOrder?MSISDN=${oldMSISDN.trim()}`)
      .then((res: any) => {
        const data = JSON.parse(res.data.body);
        if (data.error_msg == "Success") {
          const formattedData = data.Data.map((item: any) => ({
            ...item,
            date_ordered: item.date_ordered.split("T")[0],
          }));
          setUserDetail(formattedData);
          setActionFind(false);
          //setAccountID(data.user[0].AccountID.trim());
          // setOpen(true);
        } else {
          toast.error("Record not found");
        }
      })
      .catch((error: any) => {
        toast.error(error);
      })
      .finally(() => {
        setActionFind(false);
      });
  };
  const replaceSimRequest = async () => {
    toast.dismiss();
    //setAction(true);
    await axiosInterceptorInstance
      .post(`/product/updatemsisdn`, {
        OldMSISDN: oldMSISDN,
        NewMSISDN: newMSISDN,
        PoolID: activedata?.sim_pool_ref_id,
        CreditSimID: activedata?.credit_sim_order_Id,
        TransactionId: activedata.payment_ref ? activedata.payment_ref : "",
        PaymentMethod: activedata?.PaymentMethod,
      })
      .then((res: any) => {
        const data = JSON.parse(res.data.body);
        if (data.error_code != 0) {
          toast.error(data.error_message);
        }
        toast.info(data.message);
      })
      .catch((error: any) => {
        toast.error(error);
      })
      .finally(() => {
        //setAction(false);
        setOpen(false);
      });
  };

  console.log(activedata?.credit_sim_order_Id);
  const ActionsCellRenderer: React.FC<{ data: any }> = ({ data }) => {
    return (
      <Button
        onClick={() => {
          setOpen(true);
          setActiveData(data);
        }}
        className="dButton dButton2"
        variant="contained"
        style={{ width: "110px", height: "32px" }}
      >
        Update
      </Button>
    );
  };
  const columnDefs: ColDef[] = [
    {
      field: "date_ordered",
      headerName: "OrderDate",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "msisdn",
      headerName: "Msisdn",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "credit_sim_order_Id",
      headerName: "CreditSimOrderId",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "sim_pool_ref_id",
      headerName: "SimOrderPoolID",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "PaymentMethod",
      headerName: "PaymentMethod",
      filter: true,
      sortable: true,
      resizable: true,
    },

    {
      field: "email",
      headerName: "Email",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "payment_ref",
      headerName: "PaymentRef",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "address_line_1",
      headerName: "Address1",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "address_line_2",
      headerName: "Address2",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "post_code",
      headerName: "PostCode",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "city",
      headerName: "City",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "county",
      headerName: "Country",
      filter: true,
      sortable: true,
      resizable: true,
    },
    { headerName: "ChangeMsisdn", cellRenderer: ActionsCellRenderer },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">New Sim Number Replace</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                className="formControl"
                label="Old MSISDN"
                variant="outlined"
                defaultValue={oldMSISDN}
                onChange={(e) => setOldMSISDN(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>

            <Grid item xs={4}>
              {!actionFind && (
                <Button
                  onClick={handleReplaceSim}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {actionFind && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>

      {actionFind && (
        <div className="dummy-conatiner">
          <CircularProgress size={40} />
        </div>
      )}

      {userDetail && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={8}
            pagination={true}
            domLayout="autoHeight"
            rowData={userDetail}
            enableCellTextSelection={true}
            columnDefs={columnDefs}
          ></AgGridReact>
        </div>
      )}

      {activedata && (
        <Dialog
          open={Open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Update Msisdn Confirmation"}
          </DialogTitle>

          <DialogContent>
            <h3>Old Msisdn:{oldMSISDN}</h3>
            <TextField
              className="formControl"
              label="New MSISDN"
              variant="outlined"
              defaultValue={newMSISDN}
              onChange={(e) => setNewMSISDN(e.target.value)}
              inputProps={{ maxLength: 20 }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              className="dButton dButton2 dbuttonSec"
              onClick={handleUpdateMsisdn}
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </motion.div>
  );
};

export default SimReplacement;
